import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserProfile = userId =>
  call(websocketFetch, 'get_user_profile', { user_id: userId });
